import { Component, EventEmitter, Input, Output } from '@angular/core';
import { buildButtonClasses } from '../button/button-classes.util';
import type { IconButtonDensity } from '../icons/action-icon';

@Component({
  selector: 'app-edit-icon-button',
  template: `
    <button
      type="button"
      [disabled]="disabled"
      [attr.aria-label]="ariaLabel"
      [attr.title]="title || ariaLabel"
      [class]="buttonClasses"
      (click)="onClick.emit($event)"
    >
      <app-action-icon name="edit" [density]="density"></app-action-icon>
    </button>
  `,
  styleUrls: ['../icons/icon-button.scss'],
  host: {
    class: 'tt-icon-btn-host',
    '[class.tt-icon-btn-host--toolbar]': 'density === "toolbar"',
    '[class.tt-icon-btn-host--row]': 'density === "row"',
  },
})
export class EditIconButtonComponent {
  @Input() ariaLabel = 'Upravit';
  @Input() title = '';
  @Input() disabled = false;
  /** Empty follows context: 40px in the page header, 32px elsewhere. */
  @Input() density: IconButtonDensity = '';
  @Output() onClick = new EventEmitter<MouseEvent>();

  get buttonClasses(): string {
    return `${buildButtonClasses({ variant: 'secondary', size: 'sm', iconOnly: true })} shrink-0`;
  }
}
